import { render, staticRenderFns } from "./ResponsesPanel.vue?vue&type=template&id=5c215bf3&scoped=true&"
import script from "./ResponsesPanel.vue?vue&type=script&lang=js&"
export * from "./ResponsesPanel.vue?vue&type=script&lang=js&"
import style0 from "./ResponsesPanel.vue?vue&type=style&index=0&id=5c215bf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c215bf3",
  null
  
)

export default component.exports